export enum ActionButtonMode {
    AddButton,
    DropdownButtonMenu,
    DropdownButtonMenuAdd,
    DropdownButtonMenuWithLabel,
    DropdownButtonAdd,
    DropdownButtonAddSearch,
    DropdownButtonIcon,
    FavouriteButton,
    IconButton,
    LikeButton,
    LinkedButton,
    UploadButton,
    StandardButton,
}
